import type { ElplanInfoTagForDate } from 'api/elplan/elplan.types'

const BUY_SELL_ORDER = ['buy', 'sell'] as const

export function getBidTagsInBidInputOrder(
  tags: ElplanInfoTagForDate[],
  productionConsumption: ElplanInfoTagForDate['production_consumption']
): ElplanInfoTagForDate[] {
  const tagsForSelection = tags.filter((tag) => tag.production_consumption === productionConsumption)

  return BUY_SELL_ORDER.flatMap((buySell) =>
    tagsForSelection.filter((tag) => tag.buy_sell === buySell).sort((a, b) => a.tag_key.localeCompare(b.tag_key))
  )
}
